import React, { memo, useMemo } from 'react';

import { DEFAULT_PROFILE_TAG_COLOR, getProfileTagTextColor, normalizeProfileTagColor } from '../../lib/profileTag';
import { cn } from '../../lib/utils';

const ProfileTagComponent = ({ tag, hex = DEFAULT_PROFILE_TAG_COLOR, className = '' }) => {
  const style = useMemo(() => {
    const backgroundColor = normalizeProfileTagColor(hex);

    return {
      backgroundColor,
      color: getProfileTagTextColor(backgroundColor),
    };
  }, [hex]);

  if (!tag) return null;

  return (
    <span
      style={style}
      className={cn('inline-flex items-center rounded-[2px] px-0.5 font-mono text-[10px] leading-[13px] font-semibold uppercase text-black', className)}
    >
      {tag}
    </span>
  );
};

const ProfileTag = memo(ProfileTagComponent);

export default ProfileTag;
